/** Scale only the desktop layout; the existing mobile layout remains usable. */
export const SCALE_DESKTOP_WIDTH = 1600;
export const SCALE_MOBILE_BREAKPOINT = 850;
export type UiScaleMode = 'auto' | '100' | '90' | '80';

export function parseUiScaleMode(value: string | null): UiScaleMode {
  return value === '100' || value === '90' || value === '80' ? value : 'auto';
}

export function baseUiScale(viewport: number): number {
  if (!Number.isFinite(viewport) || viewport < SCALE_MOBILE_BREAKPOINT) return 1;
  return Math.min(1, viewport / SCALE_DESKTOP_WIDTH);
}

export interface OverflowMeasurement { clientWidth: number; scrollWidth: number }

/**
 * Calculate the next scale using the actual overflow and the width occupied by
 * that container in main. The ratio also covers a table in a fractional grid
 * column (for example, the feed next to its subscriptions panel).
 */
export function fitUiScale(viewport: number, current: number, mainWidth: number, boxes: OverflowMeasurement[]): number {
  if (![viewport, current, mainWidth].every(Number.isFinite) || viewport <= 0 || current <= 0 || mainWidth <= 0) return current;
  let extra = 0;
  for (const { clientWidth, scrollWidth } of boxes) {
    if (!(clientWidth > 0) || !(scrollWidth > clientWidth + 1)) continue;
    extra = Math.max(extra, (scrollWidth - clientWidth + 2) * Math.max(1, mainWidth / clientWidth));
  }
  if (!extra) return current;
  const fitted = viewport / (viewport / current + extra);
  return Math.max(0.25, Math.floor(Math.min(current, fitted) * 1000) / 1000);
}
